import React from "react";

export interface ISearchBoxProps {
  onSearchChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void | undefined;
}

const SearchBox: React.FC<ISearchBoxProps> = ({
  onSearchChange,
}): React.ReactElement => {
  return (
    <input
      aria-label="Search robots"
      type="search"
      placeholder="Search robot"
      onChange={onSearchChange}
      className="pa3 ba white bg-dark-gray border-dark-gray"
    />
  );
};

export default SearchBox;
